import React from 'react';
import { Typography, Tooltip } from '@mui/material';
import { Column } from 'components/shared/TableListing/types';
import { CalendarToday, Person, TextIncrease, FormatListNumbered } from '@mui/icons-material';

import { ChangesCell, ChangeTypeChip } from './cells';
import { CreditSubmissionChangeLogTableRow } from '../types';
import { capitalizeFirstLetter } from '../../../../formatters';

export const changeLogListingColumns: Column<CreditSubmissionChangeLogTableRow>[] = [
  {
    width: '11rem',
    header: 'Date time',
    renderKey: 'createdDateTime',
    startIcon: (
      <Tooltip arrow placement="top" title="Date when change made">
        <CalendarToday fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { createdDateTime } }) => <Typography>{createdDateTime}</Typography>,
  },
  {
    width: '12rem',
    header: 'Modified By',
    renderKey: 'modifiedBy',
    startIcon: (
      <Tooltip arrow placement="top" title="Person who made changes">
        <Person fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { modifiedBy } }) => <Typography>{modifiedBy}</Typography>,
  },
  {
    width: '12rem',
    header: 'Actor Type',
    renderKey: 'actorType',
    renderCell: ({ row: { actorType } }) => <Typography>{capitalizeFirstLetter(actorType)}</Typography>,
  },
  {
    width: '16rem',
    header: 'Change Type',
    renderKey: 'changeType',
    startIcon: (
      <Tooltip arrow placement="top" title="Change type">
        <TextIncrease fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { changeType } }) => <ChangeTypeChip changeType={changeType} />,
  },
  {
    header: 'Changes',
    renderKey: 'changes',
    startIcon: (
      <Tooltip arrow placement="top" title="What changed">
        <FormatListNumbered fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row }) => <ChangesCell log={row} />,
  },
];
